
import axios from 'axios';

const accessToken = localStorage.getItem("token");
const apiService = {
  
    async getData(endpoint) {
    try {
        
      const response = await axios.get(`${endpoint}`,{
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });
      return response;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  async postData(endpoint, data) {
      try {
          const response = await axios.post(`${endpoint}`, data,{
            headers: {
              'Authorization': `Bearer ${accessToken}`
            }
          });
          return response;
      } catch (error) {
          console.error('API Error:', error);
          throw error;
      }
  },

  async getApiNode(endpoint) {
    try {
        
      const response = await axios.get(`${endpoint}`,{
        // headers: {
        //   'Authorization': `Bearer ${accessToken}`
        // }
      });
      return response;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  async postApiNode(endpoint, data) {
    try {
        const response = await axios.post(`${endpoint}`, data,{
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        });
        return response;
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
},

};

export default apiService;

